import React from 'react';
import { SOLUTION_HIGHLIGHTS } from '../solutionsData';

const SolutionsHighlights = () => (
  <div className="solutions-highlights">
    {SOLUTION_HIGHLIGHTS.map(({ icon, title, description }) => (
      <article key={title} className="solutions-highlights__card">
        <div className="solutions-highlights__icon">
          <i className={icon} aria-hidden="true" />
        </div>
        <h3>{title}</h3>
        <p>{description}</p>
      </article>
    ))}
  </div>
);

export default SolutionsHighlights;
